
export enum MimeType {
  bmp = 'image/bmp',
  csv = 'text/csv',
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  docm = 'application/vnd.ms-word.document.macroEnabled.12',
  gif = 'image/gif',
  html = 'text/html',
  ics = 'text/calendar',
  ifb = 'text/calendar%s',
  jpeg = 'image/jpeg',
  json = 'application/json',
  md = 'text/markdown',
  msbmp = 'image/x-ms-bmp',
  onepagepdf = 'application/pdf;%s',
  pdf = 'application/pdf',
  png = 'image/png',
  pptx = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  pptm = 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  rtf = 'application/rtf',
  svg = 'image/svg+xml',
  txt = 'text/plain',
  count_tags = 'text/plain;%s',
  webp = 'image/webp',
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xlsm = 'application/vnd.ms-excel.sheet.macroEnabled.12',
  zip = 'application/zip',

}

export const IMAGE_MIME_TYPES: MimeType[] = [
  MimeType.gif,
  MimeType.jpeg,
  MimeType.png,
  MimeType.svg,
  MimeType.webp,
  MimeType.bmp,
  MimeType.msbmp,
];

export function getExtension(type: MimeType): string {
  if(!type || !type.toLowerCase){
      return '';
  }
  for (const key in MimeType) {
    if (MimeType[key].toLowerCase() === type.toLowerCase()) {
      return key;
    }
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/logic/mimeTypes.ts